/** @format */

import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import {
	refreshProductList,
	selectPageSize,
	selectTotalCount,
	setPageSizeAndPageNumber
} from '@plp/data-access/state';

import { ProductAnalyticsService } from '@shared/data-access/services';
import { ProductListUIService } from '@plp/data-access/services';
import { Store } from '@ngrx/store';

@Component({
    selector: 'plp-components-top-pagination',
    imports: [AsyncPipe, NgClass],
    templateUrl: './top-pagination.component.html',
    styleUrls: ['./top-pagination.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TopPaginationComponent implements OnDestroy {
	private readonly UNSUBSCRIBE$ = new Subject<void>();

	pageSizeOptions = this.productListUIService.getPageSizeOptions();
	readonly pageSize$ = this.store.select(selectPageSize).pipe(takeUntil(this.UNSUBSCRIBE$));
	readonly totalCount$ = this.store.select(selectTotalCount).pipe(takeUntil(this.UNSUBSCRIBE$));

	constructor(
		private readonly analyticsService: ProductAnalyticsService,
		private readonly productListUIService: ProductListUIService,
		private readonly store: Store
	) {}

	pageSizeClickEvent(newPageSize: number, oldPageSize: number): void {
		if (newPageSize !== oldPageSize) {
			this.setAnalyticsEvent(newPageSize);

			// We need to reset the Page Number because we have no guarantee there are enough products on page 30 at 144/page
			this.store.dispatch(setPageSizeAndPageNumber({ pageSize: newPageSize, pageNumber: 0 }));
			this.store.dispatch(refreshProductList());
		}
	}

	private setAnalyticsEvent(pageSize): void {
		const refinementUpdateObj = { UpdateType: 'ProductPerPage', UpdateValue: pageSize };
		this.analyticsService.triggerAnalyticsEvent('ResultsViewUpdate', refinementUpdateObj);
	}

	trackByFn(index: number, item: number): string {
		return index.toString() + item;
	}

	ngOnDestroy(): void {
		this.UNSUBSCRIBE$.next();
		this.UNSUBSCRIBE$.complete();
	}
}
